/**
 * Aturan perilaku tiap delivery_type.
 *
 * Dipusatkan di sini karena pertanyaan "tipe ini pakai stok tidak?" dan "tipe
 * ini boleh dibayar di sini tidak?" muncul di Worker maupun frontend. Sebelum
 * ini jawabannya ditulis ulang sebagai `!== "STATIC_LINK_ONLY"` di banyak
 * tempat — dan setiap tipe baru berarti sebanyak itu pula yang harus diingat.
 */

import type { DeliveryType } from "./types.js";

/** Urutan yang dipakai dropdown admin & validasi server. */
export const DELIVERY_TYPES: DeliveryType[] = [
  "SERIAL_KEY",
  "ACCOUNT_CREDENTIAL",
  "STATIC_LINK_ONLY",
  "AFFILIATE",
];

/**
 * Tipe yang mengambil barang dari license_pool, jadi stoknya bisa habis.
 * STATIC_LINK_ONLY dan AFFILIATE sama-sama tautan — tidak ada yang berkurang.
 */
export function usesStockPool(type: DeliveryType): boolean {
  return type === "SERIAL_KEY" || type === "ACCOUNT_CREDENTIAL";
}

/**
 * AFFILIATE hanya melempar pembeli ke mitra: tidak ada pesanan, tidak ada
 * pembayaran, tidak ada entitlement. Semua jalur checkout wajib menolaknya.
 */
export function isAffiliate(type: DeliveryType): boolean {
  return type === "AFFILIATE";
}

/** Boleh masuk keranjang & dibayar di toko ini. */
export function isPurchasable(type: DeliveryType): boolean {
  return !isAffiliate(type);
}

/** Wajib punya download_url — tanpa itu pembeli tidak menerima apa pun. */
export function requiresLink(type: DeliveryType): boolean {
  return type === "STATIC_LINK_ONLY" || type === "AFFILIATE";
}

/** Label untuk pembeli — bukan nama enum yang hanya dimengerti developer. */
export function deliveryLabel(type: DeliveryType | string): string {
  switch (type) {
    case "SERIAL_KEY":
      return "Kode Lisensi";
    case "ACCOUNT_CREDENTIAL":
      return "Akun";
    case "STATIC_LINK_ONLY":
      return "Tautan Produk";
    case "AFFILIATE":
      return "Affiliate";
    default:
      return String(type).replace(/_/g, " ");
  }
}
